var _circle, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 135,
    viewBox: "0 0 135 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 67.5,
    r: 67.5,
    fill: "#2BBFDC",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.3395 58.7884H62.6037L75.0242 46.3679C75.7103 45.6818 75.7103 44.5694 75.0242 43.8831L71.8769 40.7359C70.2759 39.1349 67.6803 39.1349 66.0792 40.7359L62.8432 43.972L61.1866 42.3155C59.36 40.4887 56.3876 40.4888 54.5608 42.3155L48.1006 48.7757C46.2739 50.6024 46.2739 53.5748 48.1006 55.4016L49.7571 57.0581L46.521 60.2942C44.9201 61.8951 44.9201 64.4908 46.521 66.0918L49.6683 69.2391C50.3543 69.9252 51.4668 69.9253 52.1529 69.2391L56.606 64.786V88.8145C56.606 93.0193 60.0147 96.428 64.2195 96.428H82.7261C86.9308 96.428 90.3395 93.0193 90.3395 88.8145V58.7884ZM52.2418 54.5733L50.5854 52.9168C50.1287 52.4602 50.1287 51.717 50.5854 51.2603L57.0455 44.8001C57.5023 44.3433 58.2455 44.3434 58.702 44.8001L60.3584 46.4567L52.2418 54.5733ZM67.4129 86.589C67.4129 87.5593 66.6263 88.3459 65.656 88.3459C64.6856 88.3459 63.899 87.5593 63.899 86.589V68.6274C63.899 67.657 64.6856 66.8705 65.656 66.8705C66.6263 66.8705 67.4129 67.657 67.4129 68.6274V86.589ZM75.2297 86.589C75.2297 87.5593 74.4431 88.3459 73.4728 88.3459C72.5024 88.3459 71.7158 87.5593 71.7158 86.589V68.6274C71.7158 67.657 72.5024 66.8705 73.4728 66.8705C74.4431 66.8705 75.2297 67.657 75.2297 68.6274V86.589ZM83.0465 86.589C83.0465 87.5593 82.2599 88.3459 81.2896 88.3459C80.3192 88.3459 79.5326 87.5593 79.5326 86.589V68.6274C79.5326 67.657 80.3192 66.8705 81.2896 66.8705C82.2599 66.8705 83.0465 67.657 83.0465 68.6274V86.589Z",
    fill: "url(#paint0_linear_43_7214)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4292 52.8343C74.3574 53.2079 73.6055 54.1649 73.4813 55.2753H90.3388V52.3552C90.3388 50.3502 88.3659 48.9392 86.4713 49.5816L75.4656 52.8226C75.4538 52.826 75.4409 52.8306 75.4292 52.8343Z",
    fill: "url(#paint1_linear_43_7214)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43_7214",
    x1: 45.3216,
    y1: 67.9774,
    x2: 90.3445,
    y2: 67.9774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#058CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41CFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_43_7214",
    x1: 45.3216,
    y1: 67.9774,
    x2: 90.3445,
    y2: 67.9774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#058CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41CFE3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.78fbd321e1415fd9ef2b7978320c396f.svg";
export { ForwardRef as ReactComponent };